import {
  Box,
  Grid,
  HTMLChakraProps,
  Stack,
  useColorMode,
  useMediaQuery
} from "@chakra-ui/react";

export const SvgLogoIcon = ({ ai = false }) => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient
        id="gradient"
        cx="200"
        cy="400"
        r="250"
        fx="200"
        fy="400"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0%" stopColor="#EC6181" />
        <stop offset="100%" stopColor="#5C69E3" />
      </radialGradient>
    </defs>
    <path
      d="M71.2276 400L328.772 400C368.11 400 400 368.11 400 328.772L400 71.2276C400 31.8897 368.11 2.77267e-05 328.772 2.42839e-05L71.2276 1.74419e-06C31.8897 -1.69857e-06 9.31815e-05 31.8896 8.97462e-05 71.2275L6.72553e-05 328.772C6.382e-05 368.11 31.8897 400 71.2276 400Z"
      fill={ai ? "url(#gradient)" : "#57646D"}
    />
    <path
      d="M107.144 207.349L107.144 192.634C107.144 186.838 111.847 182.134 117.643 182.134L210.945 182.134C216.74 182.134 221.444 186.838 221.444 192.634L221.444 282.357C221.444 288.152 216.74 292.856 210.945 292.856L196.229 292.856C190.433 292.856 185.729 288.152 185.729 282.357L185.729 228.348C185.729 222.553 181.026 217.849 175.23 217.849L117.643 217.849C111.847 217.849 107.144 213.145 107.144 207.349Z"
      fill="white"
    />
    <path
      d="M117.643 292.856L139.499 292.856C145.297 292.856 149.998 288.155 149.998 282.357L149.998 267.641C149.998 261.842 145.297 257.142 139.499 257.142L117.643 257.142C111.844 257.142 107.144 261.842 107.144 267.641L107.144 282.357C107.144 288.155 111.844 292.856 117.643 292.856Z"
      fill="white"
    />
    <path
      d="M107.144 132.359L107.144 117.643C107.144 111.847 111.847 107.144 117.643 107.144L251.279 107.144C251.581 107.144 251.884 107.144 252.186 107.177C273.89 108.79 291.21 126.11 292.823 147.814C292.839 148.116 292.856 148.419 292.856 148.721L292.856 282.357C292.856 288.152 288.153 292.856 282.357 292.856L267.641 292.856C261.845 292.856 257.142 288.152 257.142 282.357L257.142 153.358C257.142 147.562 252.438 142.858 246.642 142.858L117.643 142.858C111.847 142.858 107.144 138.155 107.144 132.359Z"
      fill="white"
    />
  </svg>
);

export const SvgLogoTextTaplio = ({ white = false, h = "30" }) => {
  // Calculate width proportionally based on height
  // Original SVG is 189x34, so aspect ratio is 189/34 ≈ 5.56
  const heightValue = parseFloat(h) || 32;
  const widthValue = (189 / 34) * heightValue;

  return (
    <svg
      width={widthValue}
      height={h}
      viewBox="0 0 189 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.1655 12.6136L30.8051 25.0232L34.57 12.606C34.6895 12.213 35.0408 11.9439 35.4387 11.9439H37.2257C37.8525 11.9439 38.2927 12.5863 38.0857 13.2L33.0979 28.0296C32.9696 28.409 32.6256 28.6629 32.2379 28.6629H29.6288C29.2426 28.6629 28.8986 28.4105 28.7703 28.0326L27.0999 23.1338L25.5403 17.3356L23.9472 23.1338L22.2768 28.0326C22.1485 28.4105 21.8045 28.6629 21.4183 28.6629H18.8077C18.4215 28.6629 18.076 28.409 17.9478 28.0311L12.9308 13.2015C12.7223 12.5879 13.1625 11.9439 13.7907 11.9439H15.6084C16.0063 11.9439 16.3575 12.2115 16.4771 12.606L20.242 25.0232L23.8816 12.6136C23.9982 12.216 24.3524 11.9439 24.7532 11.9439H26.2953C26.6962 11.9439 27.0504 12.216 27.167 12.6136H27.1655Z"
        fill={white ? "#FFFFFF" : "#1D1D1B"}
      />
      <path
        d="M42.5039 21.5845C42.7969 24.1132 44.8113 25.7638 47.7366 25.7638C49.0922 25.7638 50.7407 25.3179 51.8164 24.5062C52.1764 24.2342 52.6705 24.2659 52.9912 24.5879L53.8789 25.4812C54.2681 25.8727 54.2476 26.5317 53.8279 26.8854C52.1575 28.2941 49.8049 29 47.671 29C42.4048 29 39.0247 25.528 39.0247 20.2014C39.0247 14.8748 42.4383 11.5389 47.4437 11.5389C52.449 11.5389 55.7985 14.5166 55.5638 20.676C55.5449 21.1824 55.1411 21.5829 54.6529 21.5829H42.5025L42.5039 21.5845ZM52.2872 18.6521C52.0919 16.0236 50.2393 14.6405 47.5413 14.6405C45.1028 14.6405 43.0884 16.022 42.568 18.6521H52.2872Z"
        fill={white ? "#FFFFFF" : "#1D1D1B"}
      />
      <path
        d="M61.1942 21.5845C61.4872 24.1132 63.5015 25.7638 66.4269 25.7638C67.7824 25.7638 69.431 25.3179 70.5067 24.5062C70.8667 24.2342 71.3608 24.2659 71.6815 24.5879L72.5691 25.4812C72.9583 25.8727 72.9379 26.5317 72.5181 26.8854C70.8477 28.2941 68.4952 29 66.3613 29C61.0951 29 57.7149 25.528 57.7149 20.2014C57.7149 14.8748 61.1286 11.5389 66.1339 11.5389C71.1392 11.5389 74.4888 14.5166 74.2541 20.676C74.2351 21.1824 73.8314 21.5829 73.3431 21.5829H61.1927L61.1942 21.5845ZM70.9775 18.6521C70.7821 16.0236 68.9296 14.6405 66.2316 14.6405C63.793 14.6405 61.7787 16.022 61.2583 18.6521H70.9775Z"
        fill={white ? "#FFFFFF" : "#1D1D1B"}
      />
      <path
        d="M92.8849 5.9447V14.438C94.2827 12.4155 96.1673 11.7414 98.0855 11.7414C102.604 11.7414 104.684 14.8763 104.684 19.6285V27.6502C104.684 28.1717 104.276 28.5949 103.773 28.5949H102.247C101.744 28.5949 101.336 28.1717 101.336 27.6502V19.6618C101.336 16.5269 99.7749 14.9761 97.3057 14.9761C94.7054 14.9761 92.8849 17.201 92.8849 19.9308V27.6487C92.8849 28.1702 92.4768 28.5934 91.9739 28.5934H90.4478C89.9449 28.5934 89.5368 28.1702 89.5368 27.6487V5.9447C89.5368 5.42323 89.9449 5 90.4478 5H91.9739C92.4768 5 92.8849 5.42323 92.8849 5.9447Z"
        fill={white ? "#FFFFFF" : "#1D1D1B"}
      />
      <path
        d="M110.535 11.9772C111.038 11.9772 111.446 12.4004 111.446 12.9219V20.8756C111.446 23.7066 113.007 25.6626 115.801 25.6626C118.433 25.6626 120.254 23.4043 120.254 20.6398V12.9219C120.254 12.4004 120.662 11.9772 121.165 11.9772H122.691C123.194 11.9772 123.602 12.4004 123.602 12.9219V27.685C123.602 28.2064 123.194 28.6297 122.691 28.6297H121.418C120.945 28.6297 120.55 28.2518 120.51 27.7621L120.384 26.1689C118.824 28.0236 117.101 28.8655 114.858 28.8655C110.925 28.8655 108.096 25.9331 108.096 20.9103V12.9219C108.096 12.4004 108.504 11.9772 109.007 11.9772H110.535Z"
        fill={white ? "#FFFFFF" : "#1D1D1B"}
      />
      <path
        d="M139.659 27.6517V19.4865C139.659 17.0106 137.762 14.9307 135.375 14.9111C132.688 14.8884 130.85 17.1557 130.85 19.8991V27.6517C130.85 28.1732 130.442 28.5964 129.939 28.5964H128.413C127.911 28.5964 127.502 28.1732 127.502 27.6517V12.8887C127.502 12.3672 127.911 11.9439 128.413 11.9439H129.719C130.193 11.9439 130.588 12.3203 130.627 12.8101L130.753 14.3715C132.28 12.5848 134.069 11.7082 136.149 11.7082C140.049 11.7082 143.04 14.574 143.04 19.6633V27.6517C143.04 28.1732 142.632 28.5964 142.129 28.5964H140.571C140.068 28.5964 139.66 28.1732 139.66 27.6517H139.659Z"
        fill={white ? "#FFFFFF" : "#1D1D1B"}
      />
      <path
        d="M161.468 21.5845C161.761 24.1132 163.776 25.7638 166.701 25.7638C168.057 25.7638 169.705 25.3179 170.781 24.5062C171.141 24.2342 171.635 24.2659 171.956 24.5879L172.843 25.4812C173.233 25.8727 173.212 26.5317 172.792 26.8854C171.122 28.2941 168.769 29 166.636 29C161.369 29 157.989 25.528 157.989 20.2014C157.989 14.8748 161.403 11.5389 166.408 11.5389C171.413 11.5389 174.763 14.5166 174.528 20.676C174.509 21.1824 174.106 21.5829 173.617 21.5829H161.467L161.468 21.5845ZM171.252 18.6521C171.056 16.0236 169.204 14.6405 166.506 14.6405C164.067 14.6405 162.053 16.022 161.533 18.6521H171.252Z"
        fill={white ? "#FFFFFF" : "#1D1D1B"}
      />
      <path
        d="M180.44 12.8206L180.58 14.1689C181.751 12.0452 183.571 11.6069 185.294 11.6069C186.499 11.6069 187.667 11.9485 188.555 12.4941C188.971 12.7496 189.12 13.2998 188.896 13.7442L188.19 15.1454C187.957 15.6079 187.407 15.7681 186.964 15.5232C186.387 15.2043 185.753 15.0456 184.903 15.0456C182.596 15.0456 180.58 16.5284 180.58 19.5968V27.6517C180.58 28.1732 180.172 28.5964 179.669 28.5964H178.143C177.64 28.5964 177.232 28.1732 177.232 27.6517V12.9219C177.232 12.4004 177.64 11.9772 178.143 11.9772H179.535C180 11.9772 180.391 12.3415 180.44 12.8206Z"
        fill={white ? "#FFFFFF" : "#1D1D1B"}
      />
      <path
        d="M5.44971 7.34705C6.01251 7.34705 6.46874 7.82017 6.46874 8.40379V12.5024H10.238C10.7409 12.5024 11.149 12.9256 11.149 13.4471V14.558C11.149 15.0795 10.7409 15.5027 10.238 15.5027H6.43522V22.9393C6.43522 24.6927 7.18296 25.6691 8.74257 25.6691C9.1332 25.6691 9.55735 25.5845 9.97568 25.4439C10.4421 25.2867 10.9435 25.5618 11.1009 26.044L11.4828 27.2063C11.6446 27.7006 11.391 28.2417 10.9129 28.4065C10.1346 28.6755 9.3839 28.804 8.54579 28.804C5.06801 28.9053 3.0857 26.8481 3.0857 22.9393V15.5027H0.910988C0.408122 15.5027 0 15.0795 0 14.558V13.4471C0 12.9256 0.408122 12.5024 0.910988 12.5024H3.08861V8.40379C3.08861 7.82017 3.54485 7.34705 4.10764 7.34705H5.44971Z"
        fill={white ? "#FFFFFF" : "#1D1D1B"}
      />
      <path
        d="M81.1187 7.1429C81.6815 7.1429 82.1377 7.61602 82.1377 8.19964V12.5024H85.907C86.4099 12.5024 86.818 12.9256 86.818 13.4471V14.5581C86.818 15.0795 86.4099 15.5028 85.907 15.5028H82.1042V22.9393C82.1042 24.6927 82.8519 25.6691 84.4115 25.6691C84.8022 25.6691 85.2263 25.5845 85.6447 25.4439C86.1111 25.2867 86.6125 25.5618 86.7699 26.044L87.1518 27.2063C87.3136 27.7006 87.06 28.2417 86.5819 28.4065C85.8035 28.6755 85.0529 28.804 84.2148 28.804C80.737 28.9053 78.7547 26.8481 78.7547 22.9393V15.5028H76.58C76.0771 15.5028 75.669 15.0795 75.669 14.5581V13.4471C75.669 12.9256 76.0771 12.5024 76.58 12.5024H78.7576V8.19964C78.7576 7.61602 79.2138 7.1429 79.7766 7.1429H81.1187Z"
        fill={white ? "#FFFFFF" : "#1D1D1B"}
      />
      <path
        d="M150.513 7.1429C151.076 7.1429 151.532 7.61602 151.532 8.19964V12.5024H155.301C155.804 12.5024 156.212 12.9256 156.212 13.4471V14.5581C156.212 15.0795 155.804 15.5028 155.301 15.5028H151.498V22.9393C151.498 24.6927 152.246 25.6691 153.806 25.6691C154.196 25.6691 154.621 25.5845 155.039 25.4439C155.505 25.2867 156.007 25.5618 156.164 26.044L156.546 27.2063C156.708 27.7006 156.454 28.2417 155.976 28.4065C155.198 28.6755 154.447 28.804 153.609 28.804C150.131 28.9053 148.149 26.8481 148.149 22.9393V15.5028H145.974C145.471 15.5028 145.063 15.0795 145.063 14.5581V13.4471C145.063 12.9256 145.471 12.5024 145.974 12.5024H148.152V8.19964C148.152 7.61602 148.608 7.1429 149.171 7.1429H150.513Z"
        fill={white ? "#FFFFFF" : "#1D1D1B"}
      />
    </svg>
  );
};

type ExtendedProps = {
  preserveText?: boolean;
  hideLogo?: boolean;
  isOnRight?: boolean;
  overrideSmallerThan600?: boolean;
  withIcon?: boolean;
  white?: boolean;
  textOnly?: boolean;
  h?: string
  ml?: string
};
type Props = HTMLChakraProps<"svg"> & ExtendedProps;

export const LogoNew = (props: Props) => {
  const [isSmallerThan600px] = useMediaQuery("(max-width: 600px)");
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Stack
      isInline
    >
      <Grid gridTemplateColumns={"auto auto"} gap="2" alignItems="center" h={props?.h} maxH={props.h}>
        {!props.textOnly && <Box display="flex" alignItems="center" h={props?.h || "34px"}>
          <SvgLogoIcon />
        </Box>}
        <Box
          display="flex"
          alignItems="center"
          ml={props?.ml}
          h={props?.h || "34px"}
          mt={"-6px"} //good enough
        >
          <SvgLogoTextTaplio white={colorMode === "dark" || props.white} h={props?.h} />
        </Box>
      </Grid>
    </Stack>
  );
};
